import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, SimpleChanges } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';

import { BaseFormGroup } from '../../../../shared/form-input-components/base-form-group';
import {  pairwise } from 'rxjs/operators';
import { CreateBookingService } from '../../create-booking.service';
import { FormConstants } from '../../../../core/globals/form-constants';

@Component({
  selector: 'app-date-wise-booking-form',
  templateUrl: './date-wise-booking-form.component.html',
  styleUrls: ['./date-wise-booking-form.component.scss']
})
export class DateWiseBookingFormComponent extends BaseFormGroup implements OnInit, OnDestroy {

  @Input() formDetails: any;
  @Input() dateCardData: any;
  @Input() config: any;
  @Input() cabConfig: any;
  @Input() dateEditable: boolean;
  @Input() index: number;
  @Input() userDetails: any;
  @Input() dates: any[];
  @Input() bookingEditConfig: any;
  @Input() bookingCreationDisabledDays: any;
  @Input() referenceBooking: any;
  @Input() bookingFormLength: any;
  @Input() miscellConfig: any;
  @Input() workflowConfig: any;
  @Input() configComplete: any;
  @Input() designationConfig: any;


  @Output() deleteCallback = new EventEmitter();
  @Output() dateChangeCallback = new EventEmitter();
  @Output() applySameDetails = new EventEmitter();
  @Output() deleteBookingCard = new EventEmitter();

  public formError = FormConstants.errorMessages.formError;
  public dateEditActive: boolean;
  public isCabMergeWarning: boolean;
  public cabTabs = [];
  public activeCab = 0;
  public isDateCardDeleteWarning: boolean;
  public isFormVisible = true;
  private watchers = [];
  public isDuplicateDateError: boolean;
  public dateConfig = {};
  public expandView = true;

  constructor(public createBookingService: CreateBookingService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['bookingFormLength']) {
      if (changes['bookingFormLength'].currentValue === 1)
      {
this.expandView = true;
      }
    }
  }

  ngOnInit() {
    if (!this.formDetails.get('cabs').length) {
      this.addNewCab();
    }
    const cabCount = this.formDetails.get('CabCount').value;
    if (cabCount) {
      for (let index = 0; index < cabCount; index ++) {
        this.cabTabs.push({
          label: 'Booking ' + (index + 1),
          completed: true
        });
      }
    }
    this.watchers.push(
      this.formDetails.get('CabCount').valueChanges.pipe(pairwise()).subscribe(this.onCabCountChange.bind(this)),
      this.formDetails.get('CabToggle').valueChanges.subscribe(this.handleCabToggleChange.bind(this)),
      this.formDetails.get('dates').valueChanges.subscribe(this.handleDatesChange.bind(this)),
    );
    this.dateConfig['disabledDaysInWeek'] = this.bookingCreationDisabledDays;
  }

  handleDatesChange = () => {
    const cabs = this.formDetails.get('cabs');
    if (cabs instanceof FormArray && cabs.length) {
      this.updateGroupValidity(cabs);
    }
  }


  onCabCountChange = ([prev, next]: [number, number]) => {
    const cabToggle = this.formDetails.get('CabToggle').value;
    if (prev < next) {
        for (let index = prev; index < next; index ++) {
          this.cabTabs.push({
            label: 'Booking ' + (index + 1),
            completed: true
          });
          if (!cabToggle) {
            this.addNewCab();
          }
        }
      } else if (prev > next) {
        for (let index = prev - 1; index >= next; index --) {
          this.cabTabs.splice(index, 1);
          if (!cabToggle) {
            this.formDetails.get('cabs').removeAt(index);
          }
        }
      }

    if (next === 1) {
      this.formDetails.get('CabToggle').setValue(true, {emitEvent: false});
    } else if (this.activeCab >= next ) {
        this.activeCab = next - 1;
    }
  }

  addNewCab = () => {
    const cabForm = new FormGroup({});
    this.constructForm(cabForm, this.cabConfig);
    this.formDetails.get('cabs').push(cabForm);
    this.setListenersForTriggerFields(cabForm, this.cabConfig, this.watchers);
  }

  onTabChange = (tabNum: number) => {
    this.activeCab = tabNum;
  }

  onDateChange = (dateChangeObj) => {
    const next = dateChangeObj.next[0];
    const prev = dateChangeObj.prev[0];
    if (!next.isSame(prev)) {
      for (const date of this.dates) {
        if (date.isSame(next)) {
          this.toggleDuplicateDateError();
          this.formDetails.get('dates').setValue([prev]);
          this.dateEditActive = false;
          return;
        }
      }
    }
    this.dateChangeCallback.emit();
    this.dateEditActive = false;
  }

  toggleDuplicateDateError = () => {
    this.isDuplicateDateError = !this.isDuplicateDateError;
  }

  toggleDateEdit = () => {
    this.dateEditActive = !this.dateEditActive;
  }

  onCabMergeApprove = () => {
    this.activeCab = 0;
    const cabs = this.formDetails.get('cabs');
    while (cabs.length > 1) {
      cabs.removeAt(1);
    }
    this.hideCabMergeWarning();
    this.formDetails.get('CabToggle').setValue(true, {emitEvent: false});
  }

  showCabMergeWarning() {
    this.isCabMergeWarning = true;
  }

  hideCabMergeWarning() {
    this.isCabMergeWarning = false;
  }

  onCabMergeCancel = () => {
    this.formDetails.get('CabToggle').setValue(false);
    this.hideCabMergeWarning();
  }

  handleCabToggleChange = (value) => {
    if (value) {
      this.formDetails.get('CabToggle').setValue(false, {emitEvent: false});
      this.showCabMergeWarning();
      let endIndex = this.cabTabs.length - 1;
      while (this.formDetails.get('cabs').length !== 1) {
        this.formDetails.get('cabs').removeAt(endIndex);
        endIndex--;
      }
      this.activeCab = 0;
    } else {
      const cabs = this.formDetails.get('cabs');
      const cabCount = this.formDetails.get('CabCount').value;
      for (let i = 1; i < cabCount; i++) {
        const clone = this.cloneAbstractControl(cabs.at(0));
        cabs.push(clone);
      }
    }
  }

  deleteCard() {
    this.deleteCallback.emit(this.index);
  }

  hideDeleteWarning() {
    this.isDateCardDeleteWarning = false;
  }

  showDeleteWarning() {
    this.isDateCardDeleteWarning = true;
  }

  toggleView() {
    this.isFormVisible = !this.isFormVisible;
  }

  showError(formGroup: FormGroup) {
    return Boolean(formGroup && formGroup.invalid && formGroup.dirty);
  }


  toggleBooking()
  {
    this.expandView = !this.expandView;
  }
  deleteBooking()
  {
    this.deleteBookingCard.emit(this.index);
    if (this.bookingFormLength == 2)
    {
this.expandView = true;
    }
  }

  ngOnDestroy() {
    this.watchers.forEach((watcher) => {
      watcher.unsubscribe();
    });
  }
}
